import { render, staticRenderFns } from "./RetentionTrxGenerator.vue?vue&type=template&id=2dd2120f&scoped=true&"
import script from "./RetentionTrxGenerator.vue?vue&type=script&lang=js&"
export * from "./RetentionTrxGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2120f",
  null
  
)

export default component.exports